enum Languages {
  EN = "en-US",
  ES = "es-ES",
  PT = "pt-BR"
}

export default Languages;
